import { defineStore } from 'pinia';
import { ref } from 'vue';

import { SCIMSettings, SCIMSettingsUpdateParams } from '@eencloud/eewc-components/src/service/api-types';
import APIList from '@eencloud/eewc-components/src/service/api';

export const useSCIMSettingsStore = defineStore('scimSettings', function () {
  const apiKey = ref<string>('');
  const isLoadingSettings = ref<boolean>(false);
  const settings = ref<SCIMSettings | null>(null);

  const getSCIMSettings = async () => {
    try {
      isLoadingSettings.value = true;

      const response = await APIList.getSCIMSettings();

      settings.value = response ?? {};
    } catch {
      settings.value = null;
    } finally {
      isLoadingSettings.value = false;
    }
  };

  const updateSCIMSettings = async (payload: SCIMSettingsUpdateParams) => {
    try {
      const response = await APIList.updateSCIMSettings(payload);

      return response?.data?.apiKey;
    } catch (error) {
      return error;
    }
  };

  return {
    apiKey,
    getSCIMSettings,
    isLoadingSettings,
    settings,
    updateSCIMSettings,
  };
});
